import {styled} from "@mui/material/styles";
import { IconButton, Typography, TextField } from "@mui/material";
import { useColors } from "../../../Context/ColorsContext";
import { MediaQuerys } from '../../../styles/GlobalStyle';

const { mobile, tablet, desktop, desktoplarge } = MediaQuerys;

export const ContainerStyles = styled('div')(() => {
  return {
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    padding: '10px',
    borderRadius: '8px',
    marginTop: '8px',
    width: '100%',
  };
});

export const Text = styled(Typography)(() => {
  const { colors } = useColors();
  return {
      color: colors.grayFont,
      fontSize: '.8rem',
      fontWeight: 'bold',
      margin: 0,
      padding: 0,
      [desktop]: {
          fontSize: '0.95rem',
      },
      [tablet]: {
          fontSize: '0.85rem',
      }
  }
})

export const ContainerOpt = styled('div')(() => {
  return {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'space-between', 
    alignItems: 'center'
  }
})

export const Input = styled(TextField)(() => {
  const { colors } = useColors();
  return {
    '.MuiInputBase-root': {
      background: colors.white,
      height: '30px'
    },
    fontSize: '1rem', 
    flex: 1,
    '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    }
  }
})

export const CustomIconButton = styled(IconButton)(() => {
  const { colors } = useColors();
  return {
    borderRadius: "8px",
    backgroundColor: '#e9e9ea',
    color: colors.sidebarSelectColor,
    padding: '5px',
    "&:hover": {
      backgroundColor: '#e9e9ea',
      opacity: 0.8,
      color: colors.sidebarSelectColor
    },
  };
});